exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]--[hash:6]\"}!component/Grid.css"), undefined);

// module
exports.push([module.id, ".TeamList__teamList--f95d4e {\n  max-width: 1100px;\n}\n", ""]);

// exports
exports.locals = {
	"teamList": "TeamList__teamList--f95d4e " + require("-!../../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]--[hash:6]\"}!component/Grid.css").locals["containerFluid"] + ""
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/TeamList/TeamList.css
// module id = 116
// module chunks = 0